"use client";
import { useMouseMovement } from "@/app/[lang]/MouseMovementContext";

const MemberTravelLoader = ({ children, gallery }: { children?: React.ReactNode; gallery: any }) => {
    const { hasMouseMoved } = useMouseMovement();

    return hasMouseMoved ? (
        children
    ) : (
        <section>
            <img alt="gallery desktop" />
            <img alt="gallery mobile" />
            {gallery.title}
            {gallery.des}
        </section>
    );
};

export default MemberTravelLoader;
